import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { SaveUserPerosnalInfoinAllApplications } from '../../../AdminActionCreator.component';
import { getcommunityDetailsbycommId, getcommunityDetailsbycommIdForParentcommunity,UpdatecommunityForUserByData } from '../../../AdminActionCreator.component';



export default function EditPersonalDetail({PayloadBorrowerId, data, closePopup, customStyle, handleLoader, handleTextPopup, closeTextPopup, admin }) {
    const [stateData, setStateData] = useState([])
    const [dealerData, setdealerData] = useState([])
    const [objectData, setObjectData] = useState({
        agent: "",
        dealer: "",
    });

    const handleInputValues = (e) => {
        const { name, value } = e.target;

        setObjectData((prev) => ({
            ...prev,
            [name]: value
        }))

        if (name == "agent") {
            getcommunityDetailsbycommIdForParentcommunity(value, callback => {
                if (callback?.status == 200) {
                    setdealerData(callback?.data)
                } else {
                    setdealerData([])
                }
            })
        }
    }

    useEffect(() => {
        if (data || data?.agentType) {
            const type = data?.agentType == "Urja Agent" ? "Urja Agent" : "Dealer";
            getcommunityDetailsbycommId(type, callback => {
                if (callback?.status == 200) {
                    setStateData(callback?.data)
                } else {
                    setStateData([])
                }
            })
        }

        console.log("data", data)
        if (data?.userId) {
            setObjectData({
                agent: "",
                dealer: "",
            })
        } else {
            setObjectData({
                agent: "",
                dealer: "",
            })
        }
    }, [])


    const handleSave = () => {
       
        handleLoader(true)
        UpdatecommunityForUserByData(PayloadBorrowerId,String(objectData.dealer),admin.emailId,String(objectData.agent), callback => {
            if (callback?.message == "success" ) {
                handleTextPopup(true, "Information Updated Successfully")
            } else {
                handleTextPopup(true, "Error Updating Information")
            }
            handleLoader(false)
            closeTextPopup()
        })
    }


    return (
        <>
            <div className='background-blur income' style={customStyle}>
                <div className='popup-main small-popup container-fluid dbl-border'>
                    <button className='close' onClick={e => closePopup()}>
                        &times;
                    </button>
                    <h4 style={{ color: '#000' }}>Edit Agent Details</h4>

                    <div className="row">
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>

                            <TextField fullWidth id="outlined-basic" select label={data?.agentType == "Urja Agent" ? "Urja Agent" : "Dealer"} variant="outlined"  name={data?.agentType == "Urja Agent" ? "agent" : "dealer"} value={data?.agentType == "Urja Agent" ? objectData.agent : objectData.dealer}  onChange={(e) => handleInputValues(e)} >
                                {stateData?.map((option) => (
                                    <MenuItem key={option.communityId} value={option.communityId}>
                                        {option?.name}
                                    </MenuItem>
                                ))}
                            </TextField>

                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>

                            <TextField fullWidth id="outlined-basic" select label={data?.agentType == "Urja Agent" ? "Dealer" : "Urja Agent"} variant="outlined"  name={data?.agentType == "Urja Agent" ? "dealer" : "agent"} value={data?.agentType == "Urja Agent" ? objectData.dealer : objectData.agent}  onChange={(e) => handleInputValues(e)} >
                                {dealerData?.map((option) => (
                                    <MenuItem key={option.communityId} value={option.communityId}>
                                        {option?.name}
                                    </MenuItem>
                                ))}
                            </TextField>

                        </div>

                        <div className="col-xs-12" style={{ marginTop: '20px', textAlign: 'center' }}>
                            <button className='btn btn-primary' onClick={() => handleSave()}>Save</button>
                        </div>
                    </div>

                </div>


            </div >
        </>
    )
}
